export default __webpack_public_path__ + "static/media/YAS0120.34I-27678_-16603_0.ca60b4e1.jpg";